import $i18n from "./locales/i18n";
export var componentName = 'CnErrorFeedback';
export var libraryName = 'cn-error-feedback';
export var errorTypeEnum = [{
  label: $i18n.get({
    id: 'PermissionError',
    dm: '权限错误'
  }),
  value: 'permissionError',
  img: 'https://img.alicdn.com/imgextra/i1/O1CN01Ruj55h26GskugbPlp_!!6000000007635-2-tps-1666-938.png'
}, {
  label: $i18n.get({
    id: 'OperationError',
    dm: '操作错误'
  }),
  value: 'operationError',
  img: 'https://img.alicdn.com/imgextra/i2/O1CN01NDVJV71PTgLU9UyXl_!!6000000001842-2-tps-840-472.png'
}, {
  label: $i18n.get({
    id: 'BusinessError',
    dm: '业务错误'
  }),
  value: 'bizError',
  img: 'https://img.alicdn.com/imgextra/i4/O1CN01Wa1FjC27o98eTaTfA_!!6000000007843-2-tps-840-472.png'
}, {
  label: $i18n.get({
    id: '31255242825928705.CNTM',
    dm: '系统错误'
  }),
  value: 'sysError',
  img: 'https://img.alicdn.com/imgextra/i1/O1CN010eo5gI1GkKCEYZlXh_!!6000000000660-2-tps-840-108.png'
}];
export var displayModeEnum = [{
  label: $i18n.get({
    id: 'PopupWindow',
    dm: '弹窗'
  }),
  value: 'dialog'
}, {
  label: $i18n.get({
    id: 'Hint',
    dm: '提示'
  }),
  value: 'tips'
}
// , {
//   label: '抽屉',
//   value: 'drawer',
// }
];
export var errorLevelEnum = [{
  label: $i18n.get({
    id: '31255240133185536.CNTM',
    dm: '警告'
  }),
  value: 'warning'
}, {
  label: $i18n.get({
    id: 'ReportAnError',
    dm: '报错'
  }),
  value: 'error'
}];
export var errorLevelIconEnum = {
  warning: {
    icon: 'icon-exclamation-t-fill',
    color: '#FFCD00'
  },
  error: {
    icon: 'icon-error-r-fill',
    color: '#E55346'
  }
};
export var solutionTypeEnum = [{
  label: $i18n.get({
    id: 'Hyperlink',
    dm: '超链接'
  }),
  value: 'hyperlink'
}, {
  label: 'iframe',
  value: 'iframe'
}, {
  label: $i18n.get({
    id: 'Text',
    dm: '文本'
  }),
  value: 'text'
}];
export var errorTypeConfig = {
  permissionError: {
    errorContentInfo: {
      displayMode: 'dialog',
      errorTitle: $i18n.get({
        id: 'NoPermissionForTheTimeBeing_1608534244',
        dm: '暂无权限'
      }),
      errorLevel: 'warning',
      confirmTexts: $i18n.get({
        id: 'ApplyForPermission',
        dm: '申请权限'
      }),
      confirmUrl: ''
    },
    enableSolution: true,
    errorSolution: {
      enableSolution: true,
      solutionType: 'hyperlink',
      text: $i18n.get({
        id: 'ViewHelp',
        dm: '查看帮助'
      }),
      manualUrl: ''
    }
  },
  operationError: {
    errorContentInfo: {
      displayMode: 'dialog',
      errorTitle: $i18n.get({
        id: 'FailedToCreateLogisticsOrder',
        dm: '创建物流单失败'
      }),
      errorLevel: 'error',
      confirmTexts: $i18n.get({
        id: 'ImmediateProcessing',
        dm: '立即处理'
      }),
      confirmUrl: ''
    },
    enableSolution: false
  },
  bizError: {
    errorContentInfo: {
      displayMode: 'dialog',
      errorTitle: $i18n.get({
        id: 'FailureToInitiateWithdrawalAndChange_888654548',
        dm: '退改发起失败'
      }),
      errorLevel: 'error',
      confirmTexts: $i18n.get({
        id: 'ImmediateProcessing',
        dm: '立即处理'
      }),
      confirmUrl: ''
    },
    enableSolution: false
  },
  sysError: {
    errorContentInfo: {
      displayMode: 'tips',
      errorTitle: '',
      errorLevel: 'warning'
    },
    enableSolution: false
  }
};
export var langEnum = [{
  label: $i18n.get({
    id: 'Chinese',
    dm: '中文'
  }),
  value: 'zh_CN'
}, {
  label: $i18n.get({
    id: 'English',
    dm: '英语'
  }),
  value: 'en_US'
}, {
  label: $i18n.get({
    id: 'Russian',
    dm: '俄语'
  }),
  value: 'ru_RU'
}, {
  label: $i18n.get({
    id: 'Japanese',
    dm: '日语'
  }),
  value: 'ja_JP'
}, {
  label: $i18n.get({
    id: 'Hebrew',
    dm: '希伯来语'
  }),
  value: 'iw_IL'
}];